/**
 * Where the standalone subtitle generator ("Subtitles Only") can run.
 *
 * Its routes live in api_server/local_routes/subtitles.py and only the desktop
 * backend mounts them: the upload comes back as a file:// path on the machine
 * that received it, and WhisperX + NLLB run in-process. Cloud Run has neither
 * (it answers 404 for /api/v1/subtitles/*), so the sub-tab is offered exactly
 * when this frontend talks to the local API -- Electron, or a local dev
 * server -- and hidden on the web.
 *
 * ONE gate for every surface that advertises the feature (the Dubbing sub-tab
 * bar and the Audio section's tab label), so they cannot disagree.
 */

import { isLocalMode } from '@/utils/apiMode';

export function isSubtitlesOnlyAvailable(): boolean {
  return isLocalMode();
}
